import { tsValidate_optionalArrayOfUniqueIds, tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidateOptionalId } from '@nu-art/ts-common';
import { EM_RefSystems, UnresolvedCodeStatuses } from './types.js';
export const runtimeToolsDBGroup = 'runtime-tools';
const Validator_ModifiableProps = {
    refSystem: tsValidateValue([...EM_RefSystems]),
    code: tsValidateString(),
    display: tsValidateString(-1, false),
    text: tsValidateString(),
    entryId: tsValidateUniqueId,
    status: tsValidateValue([...UnresolvedCodeStatuses]),
    snippetId: tsValidateString(-1, false),
    fhirQueryLabel: tsValidateString(),
    fhirQueryId: tsValidateUniqueId,
    suggestedHvIds: tsValidate_optionalArrayOfUniqueIds,
    chosenHvId: tsValidateOptionalId,
    kbVersion: tsValidateOptionalId
};
const Validator_GeneratedProps = {};
export const DBDef_UnresolvedCode = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: [],
    versions: ['1.0.0'],
    dbKey: 'unresolved-codes',
    entityName: 'UnresolvedCode',
    frontend: {
        group: runtimeToolsDBGroup,
        name: 'unresolved-code'
    },
    backend: {
        name: 'unresolved-codes'
    },
    dependencies: {
        kbVersion: {
            dbKey: 'artifacts',
            fieldType: 'string'
        },
        chosenHvId: {
            dbKey: 'variables',
            fieldType: 'string'
        },
        snippetId: {
            dbKey: 'advisor-context',
            fieldType: 'string'
        }
    }
};
//# sourceMappingURL=db-def.js.map